module.exports = __webpack_public_path__ + "static/media/shipment-driver-icon.96111a6e.svg";